/**
 * Action Dependencies
 */
import { fetchProjects } from '../../../services/ProjectService'
import {
    updatePortfolio,
    fetchPortfolios,
    createPortfolio,
    fetchEditablePortfolio
} from '../../../services/PortfolioService'

/**
 * Retrieve the portfolio list
 *
 * @param  {Function} options.commit
 * @param  {Object} params
 * @return {Void}
 */
const getPortfolioList = ({ commit }, params = {}) => {
    commit('GET_PORTFOLIOS')
    fetchPortfolios(params)
        .then(res => commit('PORTFOLIOS_GET_SUCCESS', res.data))
        .catch(err => commit('PORTFOLIOS_GET_FAILED', err))
}

/**
 * Get and set the project list for the portfolio context
 *
 * @param  {Function} options.commit
 * @param  {Object} params
 * @return {Void}
 */
const getProjectList = ({ commit }, params = {}) => {
    commit('GET_PROJECT_LIST')
    fetchProjects(params)
        .then(res => commit('SET_PORTFOLIO_PROJECTS', res.data))
        .catch(err => commit('SET_PORTFOLIO_PROJECTS_FAILED', err))
}

/**
 * Set or remove the project id from the portfolio form
 *
 * @param  {Function} options.commit
 * @param  {Object} options.state
 * @param  {Object} action
 * @return {[type]}
 */
const updateSelectedProjects = ({ commit, state }, project) => {
    let projectIndex = state.form.selectedProjects.findIndex(item => item.id === project.id)
    if (projectIndex === -1) {
        commit('ADD_PROJECT_TO_FORM', {
            id: project.id,
            name: project.name,
            picture: project.picture
        })
    } else {
        commit('REMOVE_PROJECT_FROM_FORM', projectIndex)
    }
}

/**
 * Attempt to create a new portfolio
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Void}
 */
const createNewPortfolio = ({ commit, state }) => {
    commit('PREPARE_PORTFOLIO_SUBMISSION')
    return createPortfolio({
        name: state.form.portfolioName,
        project_ids: state.form.selectedProjects.map(item => item.id)
    })
    .then(res => commit('PORTFOLIO_CREATED_SUCCESS', res.data))
    .catch(err => commit('PORTFOLIO_CREATED_FAILURE', err.response.data))
}

/**
 * Update an existing portfolio
 *
 * @param  {Function} options.commit
 * @param  {Object} options.state
 * @param  {Number} id
 * @return {Promise}
 */
const updateExistingPortfolio = ({ commit, state }, portfolioId) => {
    commit('PREPARE_PORTFOLIO_SUBMISSION')
    return updatePortfolio(portfolioId, {
        name: state.form.portfolioName,
        project_ids: state.form.selectedProjects.map(item => item.id)
    })
    .then(res => commit('PORTFOLIO_UPDATED_SUCCESS', res.data))
    .catch(err => commit('PORTFOLIO_UPDATED_FAILURE', err.response.data))
}

/**
 * Update the project name
 *
 * @param  {Function} options.commit
 * @param  {String} value
 * @return {Void}
 */
const updatePortfolioName = ({ commit }, value) => {
    commit('UPDATE_PORTFOLIO_NAME', value)
}

/**
 * Reset the portfolio form
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
const resetForm = ({ commit }) => {
    commit('RESET_PORTFOLIO_FORM')
}

/**
 * Retrieve a portfolio for editing and manage the state
 *
 * @param  {Function} options.commit
 * @param  {Number} id
 * @return {Promise}
 */
const getEditPortfolio = ({ commit }, id) => {
    commit('GET_EDIT_PORTFOLIO')
    return fetchEditablePortfolio(id)
        .then(res => {
            return new Promise((resolve, reject) => {
                commit('GET_EDIT_PORTFOLIO_SUCCESS', res.data)
                resolve()
            })
        })
        .catch(err => {
            return new Promise((resolve, reject) => {
                commit('GET_EDIT_PORTFOLIO_FAILURE', err)
                reject(err)
            })
        })
}

/**
 * Remove a project from a portfolio
 *
 * @param  {Function} options.commit
 * @param  {Number} id
 * @return {Void}
 */
const removeProject = ({ commit, state }, id) => {
    let projectIndex = state.form.selectedProjects.findIndex(item => item.id === id)

    if (projectIndex > -1) {
        commit('REMOVE_PROJECT_FROM_FORM', projectIndex)
    }
}

/**
 * Reset the user context to its original state
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
const resetState = ({ commit }) => {
    commit('RESET_STATE')
}

export default {
    resetForm,
    resetState,
    removeProject,
    getProjectList,
    getEditPortfolio,
    getPortfolioList,
    createNewPortfolio,
    updatePortfolioName,
    updateSelectedProjects,
    updateExistingPortfolio
}



// WEBPACK FOOTER //
// ./src/state/modules/portfolios/actions.js